import { asyncComponent } from '@/components/asyncComponent'

const ReportDesigner = asyncComponent(() => import('./reportDesigner'))

export {
  ReportDesigner
}



// WEBPACK FOOTER //
// ./src/components/reportDesigner/reportDesignerAsync.js